import { humanize } from "./record/styles";

// How a directed link reads from its to end, where the plain type name would
// read backwards ("Continues" on the earlier deal).
const INCOMING_LABEL: Record<string, string> = {
  continues: "Continued by",
  related_deal: "Related to",
  referred_by: "Referred",
  coach_of: "Coached by",
};

/** A link's type as this record sees it. */
export function linkTypeLabel(link: {
  link_type_id: string;
  direction: "outgoing" | "incoming";
}) {
  return link.direction === "incoming" && INCOMING_LABEL[link.link_type_id]
    ? INCOMING_LABEL[link.link_type_id]
    : humanize(link.link_type_id);
}
